<template>
  <el-row id="container">
    <el-col :span="24" id="header-container">
      <div style="float:left;">冶金工业经济发展研究中心</div>
      <div style="float:right;">
        <span v-text="'当前用户：' + $store.state.user.username + ' / '"></span>
        <a style="color:#ffffff;" @click="handleLogout()">退出<i style=" font-size: 20px; margin-top: 18px;" class="el-icon-circle-close"></i></a>
      </div>
    </el-col>
    
    <el-col :span="3" id="main-container">
       <Affix :offset-top="60">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" unique-opened router>
          <!-- <el-menu-item index="/admin">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </el-menu-item> -->
          <el-submenu index="1">
            <template slot="title">
              <span>新闻管理</span>
            </template>
            <el-menu-item index="/admin">新闻列表</el-menu-item>
            <el-menu-item index="/issue">发布新闻</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="/category">
            <span slot="title">分类管理</span>
          </el-menu-item> -->
          <el-menu-item index="/user">
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/slide">
            <span slot="title">轮播图设置</span>
          </el-menu-item>
          <el-menu-item index="/links">
            <span slot="title">友链设置</span>
          </el-menu-item>
          <el-menu-item index="/system">
            <span slot="title">系统设置</span>
          </el-menu-item>
        </el-menu>
       </Affix>
    </el-col>

    <el-col :span="21" id="content-container">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </el-col>
  </el-row>
</template>

<script>
import { logout } from '@/api/back'
import { removeUser } from '@/utils/auth'
export default {
  methods:{
    handleLogout(){
      logout().then(res => {
        if(res.code == 20000){
          removeUser()
          this.$router.push('/login')
        }
      })
    }
  }
};
</script>

<style scoped>
html, body{
  /* display: flex;
  min-height: 100vh;
  flex-direction: column; */
  height: 90%;
}
#header-container {
  height: 60px;
  background: #4386CC;
  color: #ffffff;
  font-size: 18px;
  line-height: 60px;
  /* text-align: center; */
  position: fixed;
  top: 0;
  z-index: 1500;
  padding: 0 20px;
}
#main-container{
  display: table-cell;
  height: 100%;
  /* border-right: 1px solid #cccccc; */
  overflow: hidden;
  min-height: 660px;
  margin-top: 60px;
}
#content-container{
  /* flex: 1; */
  padding: 10px;
  margin-top: 60px;
  background: #FAFAFA;
  min-height: 660px;
}
.el-menu {
  border-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/back/layout.vue